import { styled } from '@mui/material/styles';
import { Role } from '@bloomays-lib/types.shared';
import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../stores';
import PrimesTamNav from '../molecules/PrimesTamNav';
import { PageHeader } from '../molecules/PageHeader';

const Primes = () => {
  const { t } = useTranslation(['primes']);
  const auth = useAuthStore((state) => state.auth);

  const isAdmin = auth?.user?.roles?.includes(Role.Admin) || false;
  const isSystem = auth?.user?.roles?.includes(Role.System) || false;
  // Un Tam (Admin) navigue entre ses propres primes (mois/annuel) ; un System (C-level)
  // accède directement au dashboard de synthèse, sans navigation par onglets.
  const isTam = isAdmin && !isSystem;

  if (!isAdmin && !isSystem) {
    return <Navigate to="/forbidden/norole" replace />;
  }

  return (
    <Container>
      <PageHeader id="titlePrimes" title={t('title')} />
      {isTam ? <PrimesTamNav /> : null}
      <Outlet />
    </Container>
  );
};

export default Primes;

const Container = styled('div')(() => ({
  margin: 'auto',
  width: '90%',
}));
